import React from "react";
import PropTypes from "prop-types";

const DesignationList = ({ designationList }) => {
  return designationList.map((designation, index) => (
    <tr key={index} style={{ fontSize: "12px" }}>
      <td>
        <span className="">{index + 1}</span>
      </td>
      <td>
        <span className="">{designation.designationName}</span>
      </td>
    </tr>
  ));
};

DesignationList.propTypes = {
  designationList: PropTypes.array.isRequired
};

export default DesignationList;
